export default __webpack_public_path__ + "static/media/stats.53795ba5.svg";